import AddToList from "@dana/Icons/AddToList";
import SearchIcon from "@dana/Icons/SearchIcon";
import SendIcon from "@dana/Icons/SendIcon";
import TrackIcon from "@dana/Icons/TrackIcon";
import { themeBackgrounds, themeColors } from "@dana/MobiusOverrides/styles/colors";
import translate from "@insite/client-framework/Translate";
import { AccountModel } from "@insite/client-framework/Types/ApiModels";
import Button from "@insite/mobius/Button";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon, { IconThemableProps } from "@insite/mobius/Icon";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import React from "react";
import { css } from "styled-components";

export interface IndividualVerificationEmailStyles {
    individualVerficationHeader?: GridItemProps;
    individualVerficationOptionsWrapper?: GridItemProps;
    individualVerficationOptionSearchPart?: GridItemProps;
    individualVerficationOptionAddToList?: GridItemProps;
    individualVerficationOptionSendReq?: GridItemProps;
    individualVerficationOptionTrackReq?: GridItemProps;
    individualVerificationButtonWrapper?: GridItemProps;
    individualListIcon?: IconThemableProps;
    successSignUpMessage?: TypographyPresentationProps;
    individualRegistrationMessage?: TypographyPresentationProps;
    optionsHeading?: TypographyPresentationProps;
    optionsText?: TypographyPresentationProps;
    mainIndividualContainer?: GridItemProps;
    progressArrow?: GridItemProps;
}


export const individualVerificationEmailStyles: IndividualVerificationEmailStyles =
{
    progressArrow: {
        width: 12,
        css: css`
                position: absolute;
                top: 28.5%;
                height: 1px;
                left: 86px;
                width: 77%;
                padding: 0;
                background: ${themeBackgrounds.lightGray};

                  ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null
                        ,
                        css`
                              display: none;
                            `,
                    ],
                    "max",
                )}
        `,
    },

    mainIndividualContainer: {
        width: 12,
        align: "middle",

        css: css`
            justify-content: center;
            position: absolute;
            left: 50%;
            transform: translateX(-50%);
            top: 40px;
            div {
                justify-content: center;
            }
            

        `,
    },

    individualVerficationHeader: {
        width: 12,

        css: css`
            display: block;
        `,
    },
    individualVerficationOptionsWrapper: {
        width: 12,

        css: css`
        position: relative;
        padding: 20px;
        gap: 10px;
        
             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null
                        ,
                        css`
                               display: block;
                            `,
                    ],
                    "max",
                )}
        
        `,

    },

    individualVerficationOptionSearchPart: {
        width: 12,

        css: css`
            gap: 8px;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            h6 {
                font-weight: 400;
                margin-bottom: 0px;
            }

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null
                        ,
                        css`
                            border-bottom: 2px dotted ${themeBackgrounds.lightGray};
                            padding: 24px 0;
                         `,
                    ],
                    "max",
                )}
        `,
    },
    individualVerficationOptionAddToList: {
        width: 12,

        css: css`
            gap: 8px;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null
                        ,
                        css`
                            border-bottom: 2px dotted ${themeBackgrounds.lightGray};
                            padding: 24px 0;
                         `,
                    ],
                    "max",
                )}
        `,
    },

    individualVerficationOptionSendReq: {
        width: 12,

        css: css`
            gap: 8px;
            flex-direction: column;
            justify-content: center;
            align-items: center;

            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null
                        ,
                        css`
                            border-bottom: 2px dotted ${themeBackgrounds.lightGray};
                            padding: 24px 0;
                         `,
                    ],
                    "max",
                )}
        `,
    },
    individualVerficationOptionTrackReq: {
        width: 12,

        css: css`
            gap: 8px;
            flex-direction: column;
            justify-content: center;
            align-items: center;

             ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(
                    theme,
                    [
                        null
                        ,
                        css`
                            padding: 24px 0;
                         `,
                    ],
                    "max",
                )}
        `,
    },
    individualVerificationButtonWrapper: {
        width: 12,
        css: css`
            justify-content: center;
            margin-bottom: 24px;
            margin-top: 24px;
        `
    },
    individualListIcon: {
        css: css`
            border-radius: 3rem;
            border: 1px solid ${themeBackgrounds.lightGray};
            height: 95px;
            width: 95px;
            justify-content: center;
            background: ${themeColors.primary.white};
            z-index: 1;
        `
    },

    successSignUpMessage: {
        size: 16,
        weight: 400,

        css: css`
            text-align: left;
            margin-bottom: 0px;
        `,
    },

    individualRegistrationMessage: {
        weight: 500,

        css: css`
            text-align: center;
            padding-top: 10px;
        `,
    },

    optionsHeading: {
        size: 18,
        weight: "bolder",

        css: css`
            padding-top: 10px;
            margin-bottom: 0px;
        `,
    },

    optionsText: {
        color: themeBackgrounds.darkGray,

        css: css`
            text-align: center;
        `,
    }
};

const styles = individualVerificationEmailStyles;

interface IndividualEmailVerificationPopupProps {
    account?: AccountModel;
    closeIndividualPopup: (closeModel: boolean) => void;
}
type Props = IndividualEmailVerificationPopupProps;
const IndividualEmailVerificationPopup: React.FC<Props> = ({ account, closeIndividualPopup }) => {
    const closePopup = () => {
        closeIndividualPopup(true);
    }
    return (

        <>
            <GridItem {...styles.individualVerficationHeader}>
                <Typography variant="h4" {...styles.individualRegistrationMessage}>{translate("As a registered user, here is what you can do while you are on our site.")}</Typography>
                <GridItem  {...styles.individualVerficationOptionsWrapper}>
                    <GridItem {...styles.progressArrow}></GridItem>
                    <GridItem {...styles.individualVerficationOptionSearchPart}>
                        <Icon src={SearchIcon} size={24} className="check-icon" {...styles.individualListIcon} />
                        <Typography variant="h5" {...styles.optionsHeading}>{translate("SEARCH PARTS")}</Typography>
                        <Typography as="p" {...styles.optionsText}>{translate("Use our powerful search options to spot your part quickly.")}</Typography>
                    </GridItem>

                    <GridItem {...styles.individualVerficationOptionAddToList}>
                        <Icon src={AddToList} size={24} className="check-icon" {...styles.individualListIcon} />
                        <Typography variant="h5" {...styles.optionsHeading}>{translate("ADD TO LIST")}</Typography>
                        <Typography as="p" {...styles.optionsText}>{translate(" Create and Manage multiple lists. Create RFQs for parts added to lists.")}</Typography>

                    </GridItem>

                    <GridItem {...styles.individualVerficationOptionSendReq}>
                        <Icon src={SendIcon} size={24} className="check-icon" {...styles.individualListIcon} />
                        <Typography variant="h5" {...styles.optionsHeading}>{translate("SEND RFQ")}</Typography>
                        <Typography as="p" {...styles.optionsText}>{translate("Find distributors in your area and send RFQ.")}</Typography>

                    </GridItem>

                    <GridItem {...styles.individualVerficationOptionTrackReq} className="option">
                        <Icon src={TrackIcon} size={24} className="check-icon" {...styles.individualListIcon} />
                        <Typography variant="h5" {...styles.optionsHeading}>{translate("TRACK RFQ")}</Typography>
                        <Typography as="p" {...styles.optionsText}>{translate("Track status of your RFQs until you receive quotes.")}</Typography>
                    </GridItem>
                </GridItem>

            </GridItem>
            <GridItem {...styles.individualVerificationButtonWrapper}>
                <Button
                    onClick={closePopup}
                    type="button"
                    data-test-selector="verificationEmail_createButton">
                    {translate("Continue")}
                </Button>
            </GridItem>
        </>
    );
};
export default IndividualEmailVerificationPopup;
